import getters from './getters'

import i18n from '../../../i18n'

import webFullImg from '../../../assets/faq-icons/faq1.svg'
import psd2html from '../../../assets/faq-icons/faq3.svg'
import legal from '../../../assets/faq-icons/faq5.svg'
import animations from '../../../assets/faq-icons/faq4.svg'
import agencies from '../../../assets/faq-icons/faq6.svg'
import greetings from '../../../assets/faq-icons/faq8.svg'

const state = {
  faqAll: [
    {
        img: webFullImg,
        title: i18n.t("components.faq.webFull.title"),
        paragraph: i18n.t("components.faq.webFull.paragraph"),
        slug: i18n.t("components.faq.webFull.slug"),
        serviceParam: {
          name: "Project Management"
        }
    },
    {
        img: psd2html,
        title: i18n.t("components.faq.psd2html.title"),
        paragraph: i18n.t("components.faq.psd2html.paragraph"),
        slug: i18n.t("components.faq.psd2html.slug"),
        serviceParam: {
          name:"PSD to HTMLt"
        }
    },
    {
      title: i18n.t("components.faq.animations.title"),
      img: animations,
      paragraph: i18n.t("components.faq.animations.paragraph"),
      slug: i18n.t("components.faq.animations.slug"),
      serviceParam: {
        name: "Web Animations"
      }
    },
    {
      title: i18n.t("components.faq.agencies.title"),
      img: agencies,
      paragraph: i18n.t("components.faq.agencies.paragraph"),
      slug:  i18n.t("components.faq.agencies.slug"),
      serviceParam: {
        name: "Front End Development"
      }
    },
    {
        img: legal,
        title: i18n.t("components.faq.legal.title"),
        paragraph: i18n.t("components.faq.legal.paragraph"),
        slug: i18n.t("components.faq.legal.slug"),
        serviceParam: {
          name: null
        }
    },
    {
        img: greetings,
        title: i18n.t("components.faq.greetings.title"),
        paragraph: i18n.t("components.faq.greetings.paragraph"),
        slug: i18n.t("components.faq.greetings.slug"),
        serviceParam: {
          name: null
        }
    }
]
  }
  
  export default {
    state,
    getters,
    // actions,
    // mutations
  }